import { render, staticRenderFns } from "./insurancepatients.vue?vue&type=template&id=1b8687e6"
import script from "./insurancepatients.vue?vue&type=script&lang=js"
export * from "./insurancepatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports